import styled from 'styled-components';

import { Box } from '@interstate/components/Box';

export const VehicleInsuranceInfoSlideOutContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const BodilyInjuryCoverageContainer = styled(Box)`
    border: 0.0625rem solid #b2b2b2;
    border-radius: 0.25rem;
    background-color: #f4f4f4;
    padding: 1rem;
`;
